<template>
    <div class="client-config-page page-content">
        <h4>Configuración Cliente</h4>
        <hr />
        <router-view></router-view>
    </div>
</template>
<script>
    export default {

    }
</script>